import { ProductAddonCreatePage } from '@/features/product-addon/pages/ProductAddonCreatePage'
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/admin/product-addon/create')({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["product_addon.create"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: ProductAddonCreatePage,
})
